import React, { Component } from 'react';
import Rating from 'react-rating';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class ReviewScore extends Component {
  boxStyle = {
    flex: 'wrap',
    flexWrap: 'wrap',
    width: this.props.size === 'large' ? '180px' : '140px',
    padding: '10px',
    border: this.props.size === 'large' ? 'inset' : '',
    align: 'center',
  };

  emptySymbolRed = {
    fontSize: this.props.size === 'large' ? '1.75em' : '1.4em',
    color: 'red',
  };
  emptySymbolYellow = {
    fontSize: this.props.size === 'large' ? '1.75em' : '1.4em',
    color: 'orange',
  };

  emptySymbolGreen = {
    fontSize: this.props.size === 'large' ? '1.75em' : '1.4em',
    color: 'green',
  };

  getTitle() {
    return this.props.size === 'large' ? <h5> Usability score: </h5> : '';
  }

  render() {
    return (
      <div style={this.boxStyle}>
        {this.getTitle()}
        <Rating
          initialRating={this.props.rating}
          readonly
          stop="6"
          emptySymbol={[
            <i
              className="far fa-user icon-large"
              style={this.emptySymbolRed}
            ></i>,
            <i
              className="far fa-user icon-large"
              style={this.emptySymbolRed}
            ></i>,
            <i
              className="far fa-user icon-large"
              style={this.emptySymbolYellow}
            ></i>,
            <i
              className="far fa-user icon-large"
              style={this.emptySymbolYellow}
            ></i>,
            <i
              className="far fa-user icon-large"
              style={this.emptySymbolGreen}
            ></i>,
            <i
              className="far fa-user icon-large"
              style={this.emptySymbolGreen}
            ></i>,
          ]}
          fullSymbol={[
            <i
              className="fas fa-user icon-large"
              style={this.emptySymbolRed}
            ></i>,
            <i
              className="fas fa-user icon-large"
              style={this.emptySymbolRed}
            ></i>,
            <i
              className="fas fa-user icon-large"
              style={this.emptySymbolYellow}
            ></i>,
            <i
              className="fas fa-user icon-large"
              style={this.emptySymbolYellow}
            ></i>,
            <i
              className="fas fa-user icon-large"
              style={this.emptySymbolGreen}
            ></i>,
            <i
              className="fas fa-user icon-large"
              style={this.emptySymbolGreen}
            ></i>,
          ]}
          fractions={2}
        />
        <br />

        {/* Star Variation
                    <Rating
                    emptySymbol={[<i class='far fa-star icon-large' style={emptySymbolRed}></i>,
                    <i class='far fa-star icon-large' style={emptySymbolRed}></i>,
                    <i class='far fa-star icon-large' style={emptySymbolYellow}></i>,
                    <i class='far fa-star icon-large' style={emptySymbolGreen}></i>,
                    <i class='far fa-star icon-large' style={emptySymbolGreen}></i>]}
                    fullSymbol={[<i class='fas fa-star icon-large' style={emptySymbolRed}></i>,
                    <i class='fas fa-star icon-large' style={emptySymbolRed}></i>,
                    <i class='fas fa-star icon-large' style={emptySymbolYellow}></i>,
                    <i class='fas fa-star icon-large' style={emptySymbolGreen}></i>,
                    <i class='fas fa-star icon-large' style={emptySymbolGreen}></i>]}
                    fractions={2}
                    />
                    */}
      </div>
    );
  }
}
